"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHydrogenPowerShip = function IconHydrogenPowerShip(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m20.013 10 1.414 1.414-3.063 3.063a3.5 3.5 0 0 1-.774 4.816l3.987 3.987-.01.01a3.91 3.91 0 0 1 .001 5.534 3.91 3.91 0 0 1-5.375.152l-.16-.152L12 24.791v18.196h-2v-27a3 3 0 0 0-2.824-2.995L7 12.987H3v-2h4a5 5 0 0 1 4.995 4.783l.005.217v5.976l5.447 5.447-.86.86.861-.86a1.91 1.91 0 0 0 2.706 0 1.91 1.91 0 0 0 .114-2.58l-.114-.125.823-.824-.814.813-5.3-5.3a3 3 0 0 1-.136-4.1l.136-.144zm-3.736 6.565 1.365-1.366a2.5 2.5 0 0 1-.77 3.377l-.595-.596-.087-.1a1 1 0 0 1 .087-1.315M4.745 21.987v5.655H3.718V25.16H1.036v2.482H0v-5.655h1.036v2.191h2.682v-2.19zm.819 7.073 1.054-.91.02-.017c.184-.167.371-.335.371-.555a.254.254 0 0 0-.282-.264.31.31 0 0 0-.327.346h-.91a1.1 1.1 0 0 1 1.265-1.191c.763 0 1.209.382 1.209.99-.02.433-.247.828-.61 1.064l-.554.464H8v.827H5.564zM25.586 17.74l7.5 7.259h-8.25a5 5 0 0 1-.033 2h12.783l-2-2-8.569-8.569.007-.006-.912-.912-.487.487h-.04v.039l-.841.842.842.842zM45.766 25c1.78 0 2.67 2.15 1.41 3.41L35.586 40H16v-2h18.766l4-4H29v-1h10.766l6-6h-8.17l-2-2zM24 33h4v1h-4z",
    clipRule: "evenodd"
  })));
};

export { IconHydrogenPowerShip, IconHydrogenPowerShip as default };
